import { render, staticRenderFns } from "./MedicalInsuranceLevelsCollapse.vue?vue&type=template&id=1cc6fb25&"
import script from "./MedicalInsuranceLevelsCollapse.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelsCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports